import { BlobProvider } from "@react-pdf/renderer";
import { useContext, useEffect, useRef } from "react";
import { PdfContext } from "../../context/pdf/pdf-context";
import { ResumeContext } from "../../context/resume/resume-context";
import { TranslationContext } from "../../context/translations/translations-context";
import ResumePdf from "./ResumePdf";

function PreviewTabOpener( { pdfUrl, loading, onOpened } ) {
    const hasOpened = useRef( false );

    useEffect( () => {
        if ( pdfUrl && !loading && !hasOpened.current ) {
            hasOpened.current = true;
            window.open( pdfUrl, '_blank' );
            onOpened();
        }
    }, [ pdfUrl, loading, onOpened ] );

    return null;
}

export default function ResumePdfPreviewBlob() {
    const { resumeData } = useContext( ResumeContext );
    const { translations } = useContext( TranslationContext );

    const { state, finalizePreviewTab } = useContext( PdfContext );

    if ( !state.isPreviewButtonClicked ) {
        return null;
    }

    return (
        <BlobProvider document={ <ResumePdf resumeData={ resumeData } translations={ translations }/> }>
            { ( { url, loading } ) => (
                <PreviewTabOpener
                    pdfUrl={ url }
                    loading={ loading }
                    onOpened={ finalizePreviewTab }
                />
            ) }
        </BlobProvider>
    );
}
